import React from 'react';
import { useLocation } from 'react-router-dom';
import GroupDetailsComponent from '../Components/group-details';
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';

const GroupDetails = () => {
  const location = useLocation();
  const group = String(location.state?.groupName || 'Group Details');

  const breadcrumbs: IBreadcrumb[] = [
    {
      name: 'Home',
      href: '/',
      className: 'breadcrumb-link',
    },
    {
      name: 'Group',
      href: '/admin/groups',
      className: 'breadcrumb-link',
    },
    {
      name: group,
      href: '',
      isCurrent: true,
      className: 'breadcrumb-current',
    },
  ];

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <GroupDetailsComponent />
    </>
  );
};

export default GroupDetails;
